export const numberOfRotatingAdsValues = ['2', '3', '4'] as const

export type NumberOfRotatingAds = (typeof numberOfRotatingAdsValues)[number]
